$(document).ready(function () {
  $("form#ContactForm").submit(function (event) {
    $(".professional-form-main-btn").addClass("loading");
    event.preventDefault();

    var isCheckedWithGlobalVariable = false;
    var professionalSubscribe = $('input[name="contact[professional-subscribe]"]');
    if (professionalSubscribe.is(':checked')) {
          isCheckedWithGlobalVariable = true;
      }

    var formData = {
      name: $('input[name="contact[name]"]').val(),
      email: $('input[name="contact[email]"]').val(),
      phone: $('input[name="contact[phone]"]').val(),
      practiceName: $('input[name="contact[practice-name]"]').val(),
      typeProfessional: $('select[name="contact[type-professional]"]').val(),
      recommendUsToPatients: $("form#ContactForm input[type='radio']:checked").val(),
      patientsNumber: $('input[name="contact[patients-number]"]').val(),
      address: $('input[name="contact[Address]"]').val(),
      city: $('input[name="contact[city]"]').val(),
      state: $('input[name="contact[state]"]').val(),
      zip: $('input[name="contact[zip]"]').val(),
      hearAboutUs: $('select[name="contact[hear-about-us]"]').val(),
      professionalSubscribe: isCheckedWithGlobalVariable
    };

    var scriptURL = "https://script.google.com/macros/s/AKfycbyrKJrDetl9FOZs4KYfegQ9lRxUh-Wj2XuP4LGsXcJOkXeQ1UOoCVF4y6ndnU_Yp8Sn/exec";

    $.ajax({
      url: scriptURL,
      method: "POST",
      data: formData,
      success: function (response) {
        console.log("Data sent to Google Sheets: " + response);
      },
      error: function (error) {
        console.error("Error sending data to Google Sheets: " + error);
      },
    });
  });

  $('.block-professional_form-wrapper select.professional_form_input').on('change', function (e) {
    $(this).addClass("text-color");
  });
});


  let observer = new MutationObserver(checkForElement);
  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);
  function checkForElement() {
    let element = document.querySelector('.professional_success_message');
    if (element) {
      setTimeout(function() {
        element.style.display = 'none';
      }, 5000);
    }
  }


  function Validate(event) {
    var regex = new RegExp("^[0-9-().+]");
    var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
}       